var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var Svg1PasswordIcn = function Svg1PasswordIcn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1password-icn_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24Z",
    fill: "gray"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 .828C11.619.828 1.507 10.537.86 22.76.864 35.783 11.224 46.345 24 46.345c12.777 0 23.137-10.562 23.142-23.586C46.496 10.537 36.383.83 24.001.83Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 47.175C11.188 47.175.828 36.815.828 24.002c0-.43 0-.827.031-1.226C1.49 34.993 11.618 44.692 24 44.692c12.28 0 22.345-9.57 23.142-21.652v-.264c.031.399.031.797.031 1.226 0 12.812-10.36 23.173-23.173 23.173Zm0-43.862c-11.198 0-20.275 9.077-20.275 20.275 0 6.259 2.834 11.85 7.288 15.57a18.977 18.977 0 0 1-6.047-13.915c0-10.51 8.524-19.034 19.035-19.034 10.51 0 19.034 8.524 19.034 19.035a18.977 18.977 0 0 1-6.046 13.913c4.453-3.719 7.287-9.31 7.287-15.569C44.276 12.39 35.2 3.312 24 3.312Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 42.21c10.055 0 18.207-8.15 18.207-18.206S34.055 5.797 24 5.797c-10.056 0-18.207 8.151-18.207 18.207C5.793 34.059 13.944 42.21 24 42.21Z",
    fill: "#1369BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 41.376c9.599 0 17.38-7.781 17.38-17.38 0-9.598-7.781-17.379-17.38-17.379-9.598 0-17.379 7.781-17.379 17.38 0 9.598 7.781 17.379 17.38 17.379Z",
    fill: "#198CFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 38.481c7.999 0 14.483-6.484 14.483-14.483C38.483 16 32 9.516 24 9.516 16.002 9.516 9.518 16 9.518 23.998c0 7.999 6.484 14.483 14.482 14.483Z",
    fill: "#1369BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 37.654c7.542 0 13.656-6.114 13.656-13.655 0-7.542-6.114-13.655-13.655-13.655-7.542 0-13.655 6.113-13.655 13.655 0 7.542 6.113 13.655 13.655 13.655Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 31.038a7.034 7.034 0 1 0 0-14.07 7.034 7.034 0 0 0 0 14.07Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 30.21a6.207 6.207 0 1 0 0-12.413 6.207 6.207 0 0 0 0 12.414Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 29.376a5.38 5.38 0 1 0 0-10.759 5.38 5.38 0 0 0 0 10.759Z",
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.723 34.76a1.867 1.867 0 0 1-1.862-1.863v-9.346c0-.439.154-.863.435-1.2l.548-.647a.217.217 0 0 0 0-.269l-.548-.646a1.878 1.878 0 0 1-.435-1.2v-4.485a1.867 1.867 0 0 1 1.862-1.862h4.552a1.867 1.867 0 0 1 1.862 1.862v9.347c0 .438-.154.863-.434 1.2l-.549.646a.217.217 0 0 0 0 .27l.549.646c.28.337.434.761.434 1.2v4.484a1.867 1.867 0 0 1-1.862 1.862h-4.552Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.724 14.07h4.552a1.04 1.04 0 0 1 1.034 1.035v9.346a1.05 1.05 0 0 1-.243.668l-.543.646a1.035 1.035 0 0 0 0 1.335l.543.646c.156.188.242.424.243.667v4.485a1.04 1.04 0 0 1-1.034 1.034h-4.552a1.04 1.04 0 0 1-1.035-1.034V23.55a1.05 1.05 0 0 1 .244-.667l.543-.646a1.035 1.035 0 0 0 0-1.335l-.543-.646a1.05 1.05 0 0 1-.244-.668v-4.484a1.04 1.04 0 0 1 1.035-1.035Z",
    fill: "#061A2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.724 33.105a.207.207 0 0 1-.206-.207v-9.346a.202.202 0 0 1 .046-.135l.549-.651a1.862 1.862 0 0 0 0-2.39l-.549-.652a.202.202 0 0 1-.046-.134v-4.485a.207.207 0 0 1 .206-.207h4.552a.207.207 0 0 1 .207.207v9.347a.202.202 0 0 1-.046.134l-.549.652a1.862 1.862 0 0 0 0 2.39l.549.651a.202.202 0 0 1 .046.135v4.484a.207.207 0 0 1-.207.207h-4.552Z",
    fill: "#0A2B4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1password-icn_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
};
export default Svg1PasswordIcn;